import ModuleForm from './Form';
import Utils from './Utils';

export default class Validation {
    init() {
        if (!Utils.isRingSizeProduct()) {
            return;
        }

        /* Enable or disable button on load */
        $(() => {
            this.toggleAddToCartButton();
        });

        /* Enable or disable button after combination change */
        prestashop.on('updatedProduct', () => {
            this.toggleAddToCartButton();
        });

        /* Enable or disable button after ring size field change */
        $(document).on('arsRingSizeUpdate', () => {
            this.toggleAddToCartButton();
        });

        /* Prevent click  add-to-cart (works only after button disable) */
        $(document).on('click', '.add-to-cart', (e) => {
            e.preventDefault();
            this.toggleErrors();
        });
    }

    /* Sets button state based on form validation */
    toggleAddToCartButton() {
        if (!ModuleForm.isValid()) {
            this.disableButton();
        } else {
            this.enableButton();
        }

        /* prevent validation on load - we dont need error message even if form is invalid */
        if (window.arsValidateForm) {
            this.toggleErrors();
        }
        window.arsValidateForm = true;
    }

    /* Show / hide errors based on form validation */
    toggleErrors() {
        if (!ModuleForm.isValid()) {
            this.showErrors();
        } else {
            this.hideErrors();
        }
    }

    /* Global listener will try to find [data-button-action] element, so if we manipulate this attribute, we can prevent add to cart or allow it */
    enableButton() {
        $('.add-to-cart').attr('data-button-action', 'add-to-cart');
    }

    disableButton() {
        $('.add-to-cart').removeAttr('data-button-action');
    }

    /* Show error msg element and add error class to field wrapper */
    showErrors() {
        $('.ars-form .error-msg').show();
        $('.ars-form .linked-products__container').addClass('has-error');
        $('html, body').animate(
            {
                scrollTop: $('.ars-form .linked-products__container').offset().top - 120,
            },
            1000
        );
    }

    hideErrors() {
        $('.ars-form .error-msg').hide();
        $('.ars-form .linked-products__container').removeClass('has-error');
    }
}
